import { Card } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useNotify, useRedirect } from 'react-admin'
import { FileUploadWithSlideoutPreview } from 'shared/components/FileUpload/FileUploadWithSlideoutPreview'
import { breakpoints } from 'shared/theme/breakpoints'
import styled from 'styled-components'

import { approveV2, reviewForApproval } from 'api/jobs'
import { cleanJobFormValues } from 'helpers/jobs'
import { getReadableErrorMessage } from 'helpers/utils'
import { RateConParsedStatus, ReviewForApprovalResponse } from 'models/jobs'
import { JobDiscrepancyForm } from './JobDiscrepancyForm'

export const ApproveJobV2 = (props: any) => {
  const [reviewForApprovalData, setReviewForApprovalData] = useState<ReviewForApprovalResponse | null>(
    props.location?.state?.reviewForApprovalResponse ?? null
  )
  const [hasNotifiedError, setHasNotifiedError] = useState(false)
  const notify = useNotify()
  const redirect = useRedirect()

  async function handleApproveJob(values: any) {
    values = cleanJobFormValues(values)
    if (reviewForApprovalData?.rate_con_parsed_data_id) {
      values.rate_con_parsed_data_id = reviewForApprovalData?.rate_con_parsed_data_id
    }
    let response = await approveV2(props.match.params.id, values)
    if (response.status === 200) {
      notify('Job Approved', { type: 'success' })
      redirect(`/jobs/${props.match.params.id}/show`)
    } else {
      notify('Error Approving Job', { type: 'error' })
    }
  }

  async function handleApproveJobError(error: any) {
    notify(getReadableErrorMessage(error), { type: 'error' })
  }

  useEffect(() => {
    if (reviewForApprovalData) return
    reviewForApproval(props.match.params.id)
      .then((response) => {
        if (response.data) {
          setReviewForApprovalData(response.data)
        }
      })
      .catch((error) => {
        notify(error.message, { type: 'error' })
      })
  }, [props, notify, reviewForApprovalData])

  useEffect(() => {
    if (reviewForApprovalData?.status === RateConParsedStatus.FAILED && !hasNotifiedError) {
      notify('We could not auto-fill the load information. Please enter manually.', { type: 'info' })
      setHasNotifiedError(true)
    }
  }, [reviewForApprovalData, notify, hasNotifiedError])

  return (
    <Card style={{ padding: 20 }}>
      <GridWrap>
        <JobDiscrepancyForm
          initialValues={reviewForApprovalData?.parsed_data}
          handleSubmit={handleApproveJob}
          handleError={handleApproveJobError}
          discrepancies={reviewForApprovalData?.discrepancies}
          jobId={reviewForApprovalData?.rate_confirmation?.job}
        />
        {reviewForApprovalData?.rate_confirmation?.attachments && (
          <FileUploadWithSlideoutPreview
            file={
              reviewForApprovalData?.rate_confirmation?.attachments[
                reviewForApprovalData?.rate_confirmation?.attachments.length - 1
              ]
            }
            setFile={() => {}} // This is a workaround to essentially make the file read-only
            positionExpandedUnderToolbar
            showTrashIcon={false}
          />
        )}
      </GridWrap>
    </Card>
  )
}

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: 424px 1fr;
  gap: 80px;

  @media ${breakpoints.sm} {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`
